<div class="complex-list-error">
  <ftr-illustration [illustration]="illustration.Error"></ftr-illustration>

  <div>
    <p>List failed to load.</p>
    <p>
      Please <a href class="link" (click)="$event.preventDefault(); refreshed.emit()">refresh</a> or try again later.
    </p>
  </div>
</div>
